import { useHead } from "#imports";
import { useCookieConsent } from "../composables/useCookieConsent.mjs";
export function loadScripts(config) {
  const { state } = useCookieConsent();
  useHead(() => {
    const scripts = [];
    for (const key in state.value) {
      if (state.value[key]) {
        scripts.push(
          ...config.scripts?.[key] || []
        );
      }
    }
    return {
      script: scripts
    };
  });
}
